import { jsx as _jsx } from "react/jsx-runtime";
import { lazy } from 'react';
import { useTheme } from '@mui/material';
const AquariumBlack = lazy(() => import(
// webpackChunkName: 'AquariumBlack'
'./icons/aquarium-black.svg'));
const AquariumWhite = lazy(() => import(
// webpackChunkName: 'AquariumWhite'
'./icons/aquarium-white.svg'));
const CoffeeWhite = lazy(() => import(
// webpackChunkName: 'CoffeeWhite'
'./icons/coffee-white.svg'));
const CoffeeBlack = lazy(() => import(
// webpackChunkName: 'CoffeeBlack'
'./icons/coffee-black.svg'));
const ConditionerWhite = lazy(() => import(
// webpackChunkName: 'ConditionerWhite'
'./icons/conditioner-white.svg'));
const ConditionerBlack = lazy(() => import(
// webpackChunkName: 'ConditionerBlack'
'./icons/conditioner-black.svg'));
const FloorWhite = lazy(() => import(
// webpackChunkName: 'FloorWhite'
'./icons/floor-white.svg'));
const FloorBlack = lazy(() => import(
// webpackChunkName: 'FloorBlack'
'./icons/floor-black.svg'));
const FridgeWhite = lazy(() => import(
// webpackChunkName: 'FridgeWhite'
'./icons/fridge-white.svg'));
const FridgeBlack = lazy(() => import(
// webpackChunkName: 'FridgeBlack'
'./icons/fridge-black.svg'));
const GarlandWhite = lazy(() => import(
// webpackChunkName: 'GarlandWhite'
'./icons/garland-white.svg'));
const GarlandBlack = lazy(() => import(
// webpackChunkName: 'GarlandBlack'
'./icons/garland-black.svg'));
const HeaterWhite = lazy(() => import(
// webpackChunkName: 'HeaterWhite'
'./icons/heater-white.svg'));
const HeaterBlack = lazy(() => import(
// webpackChunkName: 'HeaterBlack'
'./icons/heater-black.svg'));
const HumidifierWhite = lazy(() => import(
// webpackChunkName: 'HumidifierWhite'
'./icons/humidifier-white.svg'));
const HumidifierBlack = lazy(() => import(
// webpackChunkName: 'HumidifierBlack'
'./icons/humidifier-black.svg'));
const IronWhite = lazy(() => import(
// webpackChunkName: 'IronWhite'
'./icons/iron-white.svg'));
const IronBlack = lazy(() => import(
// webpackChunkName: 'IronBlack'
'./icons/iron-black.svg'));
const KettleWhite = lazy(() => import(
// webpackChunkName: 'KettleWhite'
'./icons/kettle-white.svg'));
const KettleBlack = lazy(() => import(
// webpackChunkName: 'KettleBlack'
'./icons/kettle-black.svg'));
const LampWhite = lazy(() => import(
// webpackChunkName: 'LampWhite'
'./icons/lamp-white.svg'));
const LampBlack = lazy(() => import(
// webpackChunkName: 'LampBlack'
'./icons/lamp-black.svg'));
const RouterWhite = lazy(() => import(
// webpackChunkName: 'RouterWhite'
'./icons/router-white.svg'));
const RouterBlack = lazy(() => import(
// webpackChunkName: 'RouterBlack'
'./icons/router-black.svg'));
const TvWhite = lazy(() => import(
// webpackChunkName: 'TvWhite'
'./icons/tv-white.svg'));
const TvBlack = lazy(() => import(
// webpackChunkName: 'TvBlack'
'./icons/tv-black.svg'));
const VentilatorWhite = lazy(() => import(
// webpackChunkName: 'VentilatorWhite'
'./icons/ventilator-white.svg'));
const VentilatorBlack = lazy(() => import(
// webpackChunkName: 'VentilatorBlack'
'./icons/ventilator-black.svg'));
const WasherWhite = lazy(() => import(
// webpackChunkName: 'WasherWhite'
'./icons/washer-white.svg'));
const WasherBlack = lazy(() => import(
// webpackChunkName: 'WasherBlack'
'./icons/washer-black.svg'));
const GatesWhite = lazy(() => import(
// webpackChunkName: 'GatesWhite'
'./icons/gates-white.svg'));
const GatesBlack = lazy(() => import(
// webpackChunkName: 'GatesBlack'
'./icons/gates-black.svg'));
const RollershuttersWhite = lazy(() => import(
// webpackChunkName: 'RollershuttersWhite'
'./icons/rollershutters-white.svg'));
const RollershuttersBlack = lazy(() => import(
// webpackChunkName: 'RollershuttersBlack'
'./icons/rollershutters-black.svg'));
const SocketWhite = lazy(() => import(
// webpackChunkName: 'SocketWhite'
'./icons/socket-white.svg'));
const SocketBlack = lazy(() => import(
// webpackChunkName: 'SocketBlack'
'./icons/socket-black.svg'));
const White220v = lazy(() => import(
// webpackChunkName: 'White220v'
'./icons/220v-white.svg'));
const Black220v = lazy(() => import(
// webpackChunkName: 'Black220v'
'./icons/220v-black.svg'));
const White380v = lazy(() => import(
// webpackChunkName: 'White380v'
'./icons/380v-white.svg'));
const Black380v = lazy(() => import(
// webpackChunkName: 'Black380v'
'./icons/380v-black.svg'));
const CommutatorBlack = lazy(() => import(
// webpackChunkName: 'CommutatorBlack'
'./icons/commutator-black.svg'));
const CommutatorWhite = lazy(() => import(
// webpackChunkName: 'CommutatorWhite'
'./icons/commutator-white.svg'));
const DvrWhite = lazy(() => import(
// webpackChunkName: 'DvrWhite'
'./icons/dvr-white.svg'));
const DvrBlack = lazy(() => import(
// webpackChunkName: 'DvrBlack'
'./icons/dvr-black.svg'));
const SpotlightBlack = lazy(() => import(
// webpackChunkName: 'SpotlightBlack'
'./icons/spotlight-black.svg'));
const SpotlightWhite = lazy(() => import(
// webpackChunkName: 'SpotlightWhite'
'./icons/spotlight-white.svg'));
const ElockBlack = lazy(() => import(
// webpackChunkName: 'ElockBlack'
'./icons/elock-black.svg'));
const ElockWhite = lazy(() => import(
// webpackChunkName: 'ElockWhite'
'./icons/elock-white.svg'));
const OntBlack = lazy(() => import(
// webpackChunkName: 'OntBlack'
'./icons/ont-black.svg'));
const OntWhite = lazy(() => import(
// webpackChunkName: 'OntWhite'
'./icons/ont-white.svg'));
const BlackWhiteIcon = (LightIcon, DarkIcon) => {
    return (props) => {
        const theme = useTheme();
        if (theme.palette.mode === 'dark') {
            // @ts-ignore
            return _jsx(LightIcon, { ...props });
        }
        // @ts-ignore
        return _jsx(DarkIcon, { ...props });
    };
};
export const styled_tariff_icons = [
    {
        id: 321,
        render: BlackWhiteIcon(AquariumWhite, AquariumBlack),
        title: 'Аквариум',
        paid: true,
        styled: true,
    },
    {
        id: 322,
        render: BlackWhiteIcon(CoffeeWhite, CoffeeBlack),
        title: 'Кофеварка',
        paid: true,
        styled: true,
    },
    {
        id: 323,
        render: BlackWhiteIcon(ConditionerWhite, ConditionerBlack),
        title: 'Кондиционер',
        paid: true,
        styled: true,
    },
    {
        id: 324,
        render: BlackWhiteIcon(FloorWhite, FloorBlack),
        title: 'Теплый пол',
        paid: true,
        styled: true,
    },
    {
        id: 325,
        render: BlackWhiteIcon(FridgeWhite, FridgeBlack),
        title: 'Холодильник',
        paid: true,
        styled: true,
    },
    {
        id: 326,
        render: BlackWhiteIcon(GarlandWhite, GarlandBlack),
        title: 'Гирлянда',
        paid: true,
        styled: true,
    },
    {
        id: 327,
        render: BlackWhiteIcon(HeaterWhite, HeaterBlack),
        title: 'Обогреватель',
        paid: true,
        styled: true,
    },
    {
        id: 328,
        render: BlackWhiteIcon(HumidifierWhite, HumidifierBlack),
        title: 'Увлажнитель воздуха',
        paid: true,
        styled: true,
    },
    {
        id: 329,
        render: BlackWhiteIcon(IronWhite, IronBlack),
        title: 'Утюг',
        paid: true,
        styled: true,
    },
    {
        id: 330,
        render: BlackWhiteIcon(KettleWhite, KettleBlack),
        title: 'Чайник',
        paid: true,
        styled: true,
    },
    {
        id: 331,
        render: BlackWhiteIcon(LampWhite, LampBlack),
        title: 'Светильник',
        paid: true,
        styled: true,
    },
    {
        id: 332,
        render: BlackWhiteIcon(RouterWhite, RouterBlack),
        title: 'Роутер',
        paid: true,
        styled: true,
    },
    {
        id: 333,
        render: BlackWhiteIcon(TvWhite, TvBlack),
        title: 'Телевизор',
        paid: true,
        styled: true,
    },
    {
        id: 334,
        render: BlackWhiteIcon(VentilatorWhite, VentilatorBlack),
        title: 'Вентилятор',
        paid: true,
        styled: true,
    },
    {
        id: 335,
        render: BlackWhiteIcon(WasherWhite, WasherBlack),
        title: 'Стиральная машинка',
        paid: true,
        styled: true,
    },
    {
        id: 336,
        render: BlackWhiteIcon(GatesWhite, GatesBlack),
        title: 'Ворота',
        paid: true,
        styled: true,
    },
    {
        id: 337,
        render: BlackWhiteIcon(RollershuttersWhite, RollershuttersBlack),
        title: 'Рольставни',
        paid: true,
        styled: true,
    },
    {
        id: 338,
        render: BlackWhiteIcon(SocketWhite, SocketBlack),
        title: 'Розетка',
        paid: true,
        styled: true,
    },
    {
        id: 339,
        render: BlackWhiteIcon(White220v, Black220v),
        title: '220 Вольт',
        paid: true,
        styled: true,
    },
    {
        id: 340,
        render: BlackWhiteIcon(White380v, Black380v),
        title: '380 Вольт',
        paid: true,
        styled: true,
    },
    {
        id: 341,
        render: BlackWhiteIcon(CommutatorWhite, CommutatorBlack),
        title: 'Коммутатор',
        paid: true,
        styled: true,
    },
    {
        id: 342,
        render: BlackWhiteIcon(DvrWhite, DvrBlack),
        title: 'Видеорегистратор',
        paid: true,
        styled: true,
    },
    {
        id: 343,
        render: BlackWhiteIcon(SpotlightWhite, SpotlightBlack),
        title: 'Прожектор',
        paid: true,
        styled: true,
    },
    {
        id: 344,
        render: BlackWhiteIcon(ElockWhite, ElockBlack),
        title: 'Элекромагнитный замок',
        paid: true,
        styled: true,
    },
    {
        id: 345,
        render: BlackWhiteIcon(OntWhite, OntBlack),
        title: 'Оптический терминал',
        paid: true,
        styled: true,
    },
];
